/**
 * External Print Status Constants
 * Defines the possible states for external print processing
 */
export const EXTERNAL_PRINT_STATUS = {
  NONE: 'None',
  APPROVED: 'Approved',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
};

/**
 * Valid transitions for external print status
 */
export const EXTERNAL_PRINT_STATUS_TRANSITIONS = {
  [EXTERNAL_PRINT_STATUS.NONE]: [EXTERNAL_PRINT_STATUS.APPROVED],
  [EXTERNAL_PRINT_STATUS.APPROVED]: [EXTERNAL_PRINT_STATUS.PROCESSING],
  [EXTERNAL_PRINT_STATUS.PROCESSING]: [EXTERNAL_PRINT_STATUS.COMPLETED],
  [EXTERNAL_PRINT_STATUS.COMPLETED]: [], // Terminal state
};
